/**
 * angular
 */
angular.module('jv.MyAccount.Svc',[])
    .service('myAccount', ['$http', '$window', '$q', 'makeAjaxCall', function($http, $window, $q, makeAjaxCall){
        var adminUrl = $window.jvUrls.admin;
        var talentNetworkURL = $window.jvUrls.source+'/action';
        var myAccountUrl = adminUrl+'/action/myAccount';
        var integrationURL = adminUrl+'/action/integration';

        function createRequestObject(args, callback, options, onError) {
            var _args = {
                headers : {
                    'Content-Type': 'application/json; charset=UTF-8'
                }
            };
            callback = (callback || angular.noop);
            var requestObj = args || _args;
            requestObj.ajaxtype = options.ajaxtype;
            requestObj.url = options.url;
            requestObj.requestType = options.requestType || 'GET';
            requestObj.cache = options.cache || false;
            var requestPromise = makeAjaxCall(requestObj);
            requestPromise.then(function(results) {
                callback(results.data, results.status);
            }, function(error){
                if(onError){
                    onError(error);
                }
            });
        }

        this.getProfilePicture = function(data, callback, fail){
            var url = myAccountUrl+'/profilePhoto?'+$.param(data);
            var ajaxOptions = {
                'ajaxtype': 'getProfilePicture',
                'url': url
            };
            createRequestObject(null, callback, ajaxOptions, fail);
        };

        this.saveProfileDetails = function(user, callback, fail){
            var url = myAccountUrl+'/details';
            var ajaxOptions = {
                'ajaxtype': 'saveProfileDetails',
                'url': url,
                'requestType': 'POST'
            };
            user.headers = {'Content-Type':'application/json; charset=UTF-8'};
            createRequestObject(user, callback, ajaxOptions,fail);
        };

        this.notifyChangeEmail = function(data, callback, fail){
            var url = myAccountUrl+'/changeEmailNotify';
            var opts = {
                data: data || ''
            };
            var ajaxOptions = {
                'ajaxtype': 'notifyChangeEmail',
                'url': url,
                'requestType': 'POST'
            };
            opts.passAsStringParam = true;
            opts.headers = {'Content-Type':'application/json; charset=UTF-8'};
            createRequestObject(opts, callback, ajaxOptions,fail);
        };

        this.getProfileDetails = function(callback, fail){
            var url = myAccountUrl+'/details';
            var ajaxOptions = {
                'ajaxtype': 'getProfileDetails',
                'url': url
            };
            createRequestObject(null, callback, ajaxOptions, fail);
        };

        this.saveProfilePicture = function(data, callback, fail){
            var url = myAccountUrl+'/cropProfilePhoto';
            var ajaxOptions = {
                'ajaxtype': 'saveProfilePicture',
                'url': url,
                'requestType': 'POST'
            };
            data.headers = {'Content-Type':'application/json; charset=UTF-8'};
            createRequestObject(data, callback, ajaxOptions,fail);
        };

        this.deleteProfilePicture = function(callback, fail){
            var url = myAccountUrl+'/profilePhoto';
            var ajaxOptions = {
                'ajaxtype': 'deleteProfilePicture',
                'url': url,
                'requestType': 'DELETE'
            };
            createRequestObject(null, callback, ajaxOptions,fail);
        };

        this.uploadProfilePicture = function(fileData, cropData, callback, fail){
            var fd = new FormData();
            fd.append('qqfile', fileData);
            fd.append('cropData', angular.toJson(cropData));
            var url = myAccountUrl+'/profilePhoto';
            var ajaxOptions = {
                'ajaxtype': 'uploadProfilePicture',
                'url': url,
                'requestType': 'POST'
            };
            fd.headers = { 'Content-Type': angular.noop() };
            fd.transformRequest = angular.identity;
            createRequestObject(fd, callback, ajaxOptions,fail);
        };

        this.getLanguageDateInfo = function(callback, fail){
            var url = myAccountUrl+'/dateTimeLanguagePreferences';
            var ajaxOptions = {
                'ajaxtype': 'getLanguageDateInfo',
                'url': url
            };
            createRequestObject(null, callback, ajaxOptions, fail);
        };

        this.saveRegionLanguageDetails = function(data, callback, fail){
            var url = myAccountUrl+'/dateTimeLanguagePreferences';
            var ajaxOptions = {
                'ajaxtype': 'saveRegionLanguageDetails',
                'url': url,
                'requestType': 'POST'
            };
            data.headers = {'Content-Type':'application/json; charset=UTF-8'};
            createRequestObject(data, callback, ajaxOptions,fail);
        };

        this.getAdditionalInfo = function(callback, fail){
            var url = myAccountUrl+'/additionalInfo';
            var ajaxOptions = {
                'ajaxtype': 'getAdditionalInfo',
                'url': url
            };
            createRequestObject(null, callback, ajaxOptions, fail);
        };

        this.saveAdditionalInfo = function(data, callback, fail){
            var url = myAccountUrl+'/additionalInfo';
            var ajaxOptions = {
                'ajaxtype': 'saveAdditionalInfo',
                'url': url,
                'requestType': 'POST'
            };
            data.headers = {'Content-Type':'application/json; charset=UTF-8'};
            createRequestObject(data, callback, ajaxOptions,fail);
        };

        this.validateCurrentPassword = function(data, callback, fail){
            var url = myAccountUrl+'/validateCurrentPassword';
            var ajaxOptions = {
                'ajaxtype': 'validateCurrentPassword',
                'url': url,
                'requestType': 'POST'
            };
            data.headers = {'Content-Type':'application/x-www-form-urlencoded; charset=UTF-8'};
            createRequestObject(data, callback, ajaxOptions,fail);
        };

        this.updatePassword = function(data, callback, fail){
            var url = myAccountUrl+'/updatePassword';
            var ajaxOptions = {
                'ajaxtype': 'updatePassword',
                'url': url,
                'requestType': 'POST'
            };
            data.headers = {'Content-Type':'application/x-www-form-urlencoded; charset=UTF-8'};
            createRequestObject(data, callback, ajaxOptions,fail);
        };

        this.getPreferences = function(callback, fail){
            var url = myAccountUrl+'/preferences';
            var ajaxOptions = {
                'ajaxtype': 'getPreferences',
                'url': url
            };
            createRequestObject(null, callback, ajaxOptions, fail);
        };

        this.savePreferences = function(data, callback, fail){
            var url = myAccountUrl+'/preferences';
            var ajaxOptions = {
                'ajaxtype': 'savePreferences',
                'url': url,
                'requestType': 'POST'
            };
            data.headers = {'Content-Type':'application/json; charset=UTF-8'};
            createRequestObject(data, callback, ajaxOptions,fail);
        };

        this.getNotifications = function(page, callback, fail){
            var data = {
                page: page
            };
            var url = myAccountUrl+'/notifyPreferences?'+$.param(data);
            var ajaxOptions = {
                'ajaxtype': 'getNotifications',
                'url': url
            };
            createRequestObject(null, callback, ajaxOptions, fail);
        };

        this.getCompanyNotifications = function(companyEId, data, callback, fail){
            var url = myAccountUrl+'/company/'+companyEId+'/notifyPreferences?'+$.param(data);
            var ajaxOptions = {
                'ajaxtype': 'getCompanyNotifications',
                'url': url
            };
            createRequestObject(null, callback, ajaxOptions, fail);
        };

        this.saveNotifications = function(companyEId, subsidiaryEId, data, callback, fail){
            var param = {
                subsidiaryEId: subsidiaryEId || 0
            };
            var url = myAccountUrl+'/company/'+companyEId+'/notifyPreferences?'+$.param(param);
            var ajaxOptions = {
                'ajaxtype': 'saveNotifications',
                'url': url,
                'requestType': 'POST'
            };
            data.headers = {'Content-Type':'application/json; charset=UTF-8'};
            createRequestObject(data, callback, ajaxOptions, fail);
        };

        this.removeNotifications = function(companyEId, subsidiaryEId, callback, fail){
            var param = {
                subsidiaryEId: subsidiaryEId || 0
            };
            var url = myAccountUrl+'/company/'+companyEId+'/notifyPreferences?'+$.param(param);
            var ajaxOptions = {
                'ajaxtype': 'saveNotifications',
                'url': url,
                'requestType': 'DELETE'
            };
            createRequestObject(null, callback, ajaxOptions, fail);
        };

        this.getCountries = function(callback, fail){
            var url = talentNetworkURL+'/sys/countries';
            var ajaxOptions = {
                'ajaxtype': 'getCountries',
                'url': url
            };
            createRequestObject(null, callback, ajaxOptions, fail);
        };

        this.refreshUserSession = function(){
            $http.get($window.jvUrls.forum + 'api/api.aspx?command=refreshusersession&r='+Math.floor((Math.random()*1000000)+1));
        };

        this.getEmailTemplates = function(page, search) {
            // TODO: set cache
            return $http.get(myAccountUrl + '/userEmailTemplate/list', {
                params: {
                    page: page || 0,
                    keywords: search
                }
            });
        };

        this.getEmailTemplate = function(id) {
            return $http.get(myAccountUrl + '/userEmailTemplate/' + id);
        };

        this.deleteEmailTemplate = function(template) {
            // TODO: clear cache
            return $http({
                url: myAccountUrl + '/userEmailTemplate/' + template.SId,
                method: 'DELETE'
            });
        };

        this.saveEmailTemplate = function(template) {
            // TODO: clear cache
            var tpl = angular.copy(template);
            delete tpl.SId;
            tpl.id = template.SId;
            return $http.post(myAccountUrl + '/userEmailTemplate/createOrUpdate', tpl);
        };

        this.getTokens = function() {
            return $http.get(myAccountUrl + '/userEmailTemplate/tokens');
        };

        this.getJobAlertCompanies = function() {
            var url = myAccountUrl + '/jobAlerts/companies';
            return $http.get(url).then(function(response) {
                var companies = {};
                if (response.data.resultList) {
                    response.data.companies.forEach(function(item) {
                        companies[item.EId] = item.name;
                    });
                    return {
                        allowJobAlertCreation: response.data.allowJobAlertCreation,
                        companies: response.data.resultList.map(function(item) {
                            return angular.extend({}, item, {
                                name: companies[item.companyEId]
                            });
                        })
                    };
                }
                else {
                    return {
                        companies: [],
                        allowJobAlertCreation: response.data.allowJobAlertCreation
                    };
                }
            });
        };

        this.getJobAlerts = function(companyEId) {
            var url = myAccountUrl + '/jobAlerts/company/' + companyEId;
            return $http.get(url).then(function(response) {
                var categories = {};
                var jobAlertSubscriptionLocations = {};
                if (response.data.resultList) {
                    response.data.company.categories.forEach(function(item) {
                        categories[item.EId] = item.name;
                    });
                    response.data.company.jobAlertSubscriptionLocations.forEach(function(item) {
                        jobAlertSubscriptionLocations[item.locationKey] = item.locationName;
                    });
                    return {
                        alerts: response.data.resultList.map(function(item) {
                            return angular.extend({}, item, {
                                locationName: item.subscriptionType ==='ActualLocation' ?jobAlertSubscriptionLocations[item.subscribedLocation] :jobAlertSubscriptionLocations[item.locationEId] ,
                                categoryName: categories[item.categoryEId],
                                companyEId: companyEId
                            });
                        }),
                        categories: response.data.company.categories,
                        jobAlertSubscriptionLocations: response.data.company.jobAlertSubscriptionLocations,
                        activeJobAlertSubscriptionLocations:response.data.activeJobAlertSubscriptionLocations
                    };
                }
                else {
                    return {};
                }
            });
        };
        
        this.getCompany = function(companyEId) {
            var url = myAccountUrl + '/company/' + companyEId;
            return $http.get(url).then(function(response) {
                if (response && response.data && response.data.company) {
                    return {
                        categories: response.data.company.categories,
                        jobAlertSubscriptionLocations: response.data.activeJobAlertSubscriptionLocations
                    };
                }
                else {
                    return {};
                }
            });
        };

        this.saveJobAlert = function(alert) {
            var url = myAccountUrl + '/jobAlerts/subscription/' + alert.EId;
            var param = {
                categoryEId: alert.categoryEId
            };
            return $http.put(url + '?' + $.param(param),alert.location).then(function(response) {
                if (response.data.msgInfo === 200) {
                    return true;
                }
                return $q.reject();
            });
        };
        
        this.createJobAlert = function(alert) {
            if(alert && alert.categoryEId) {
                var url = myAccountUrl + '/jobAlerts/subscription';
                var param = {
                    categoryEId: alert.categoryEId
                };
                return $http.post(url + '?' + $.param(param),alert.location).then(function(response) {
                    if (response.data.msgInfo === 200) {
                        return true;
                    }
                    return $q.reject();
                });
            }
        };

        this.deleteJobAlert = function(alertEId) {
            var url = myAccountUrl + '/jobAlerts/subscription/' + alertEId;
            return $http.delete(url).then(function(response) {
                if (response.data.msgInfo === 200) {
                    return true;
                }
                return $q.reject();
            });
        };

        this.deleteAllJobAlerts = function(companyEId) {
            var url = myAccountUrl + '/jobAlerts/company/' + companyEId + '?action=delete';
            return $http.put(url);
        };

        this.renewAllJobAlerts = function(companyEId) {
            var url = myAccountUrl + '/jobAlerts/company/' + companyEId + '?action=renew';
            return $http.put(url).then(function(response) {
                if (response.data.resultList && response.data.resultList[0]) {
                    return response.data.resultList[0].expiresInDays;
                }
                return $q.reject();
            });
        };
        
        this.getLinkedInAdminSetting = function(callback, fail){
            var url = integrationURL+'/linkedIn?_='+new Date().getTime();
            var ajaxOptions = {
                'ajaxtype': 'getLinkedInAdminSetting',
                'url': url
            };
            createRequestObject(null, callback, ajaxOptions, fail);
        };
     
        this.saveLinkedInUserPreference = function(data, callback, fail){
            var url = myAccountUrl+'/linkedIn/userSettings';
            var ajaxOptions = {
                'ajaxtype': 'saveLinkedInUserPreference',
                'url': url,
                'requestType': 'POST'
            };
            data.headers = {'Content-Type':'application/json; charset=UTF-8'};
            createRequestObject(data, callback, ajaxOptions, fail);
        };
        
        this.getLinkedInUserPreference = function(callback, fail){
            var url = myAccountUrl+'/linkedIn/userSettings';
            var ajaxOptions = {
                'ajaxtype': 'getLinkedInUserPreference',
                'url': url
            };
            createRequestObject(null, callback, ajaxOptions, fail);
        };
    }])
    .factory('myAccountCache', [
        '$cacheFactory',
        function($cacheFactory) {
            var cf = $cacheFactory('myAccount');
            return cf;
        }
    ]);
